export const isLottoSummaryAllZero = (lottoSummary: any): boolean => {
  if (!lottoSummary) return true;
  return (
    (lottoSummary.sales ?? 0) === 0 &&
    (lottoSummary.payouts_total ?? 0) === 0 &&
    (lottoSummary.payouts_count ?? 0) === 0 &&
    (lottoSummary.lotto_payouts_amount ?? 0) === 0 &&
    (lottoSummary.lotto_payouts_count ?? 0) === 0 &&
    (lottoSummary.scratcher_payouts_amount ?? 0) === 0 &&
    (lottoSummary.scratcher_payouts_count ?? 0) === 0 &&
    (lottoSummary.activated_count ?? 0) === 0 &&
    (lottoSummary.activated_amount ?? 0) === 0 &&
    (lottoSummary.scratcher_free_tickets_paid_amount ?? 0) === 0
  );
};

export const isPosSummaryAllZero = (posSummary: any): boolean => {
  if (!posSummary) return true;
  return (
    (posSummary.scratcher_count ?? 0) === 0 &&
    (posSummary.scratcher_sales ?? 0) === 0 &&
    (posSummary.lotto_sales ?? 0) === 0 &&
    (posSummary.payout ?? 0) === 0
  );
};

